import scandinavia  from '../../../images/partners/part1.jpg';
import laddy from '../../../images/partners/part2.jpg';
import casa from '../../../images/partners/part3.jpg';
import bark from '../../../images/partners/part4.jpg';
import appgames from "../../../images/partners/part5.jpg";
import bean from "../../../images/partners/part6.jpg";

let PartnerObj = [
  {
    id: 10,
    image: scandinavia,
  },
  {
    id: 11,
    image: laddy,
  },
  {
    id: 12,
    image: casa,
  },
  {
    id: 13,
    image: bark,
  },
  {
    id: 14,
    image: appgames,
  },
  {
    id: 15,
    image: bean,
  },
  {
    id: 16,
    image: appgames,
  },
];

export default PartnerObj;